import React from 'react';
import useBlockStyles from '../common/useBlockStyles';

const STYLE_OPTIONS = {
  defaultBackground: 'card',
  defaultHeadingSize: 'medium',
  defaultAlignment: 'left',
  defaultPadding: 'normal',
};

/**
 * RichTextBlockRenderer - Render component for rich-text block
 */
const RichTextBlockRenderer = ({ block, theme = {} }) => {
  const { content } = block;
  const { maxWidth = 'normal' } = content;
  const styles = useBlockStyles(content, theme, STYLE_OPTIONS);

  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center mx-auto',
    right: 'text-right ml-auto',
  };

  const maxWidthClasses = {
    narrow: 'max-w-2xl',
    normal: 'max-w-4xl',
    wide: 'max-w-6xl',
  };

  // Split body into paragraphs
  const body = content.body;
  const paragraphs = body
    ? body.split(/\n\s*\n/).filter((p) => p.trim())
    : [];

  return (
    <div
      className={`w-full ${styles.sectionPaddingClass}`}
      style={{ backgroundColor: styles.sectionBackground }}
    >
      <div className={`${maxWidthClasses[maxWidth]} ${alignmentClasses[styles.headingAlignment]}`}>
        {/* Heading */}
        {content.heading && (
          <h3
            className={`${styles.headingSizeClass} font-bold mb-4 sm:mb-6`}
            style={{ color: styles.headingColor, fontFamily: styles.headingFontStyle }}
          >
            {content.heading}
          </h3>
        )}

        {/* Body Paragraphs */}
        <div className="space-y-3 sm:space-y-4">
          {paragraphs.length > 0 ? (
            paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className="text-base sm:text-lg leading-relaxed sm:leading-relaxed whitespace-pre-wrap opacity-90"
                style={{ color: styles.bodyColor, fontFamily: styles.bodyFontStyle }}
              >
                {paragraph.trim()}
              </p>
            ))
          ) : (
            body && (
              <p
                className="text-base sm:text-lg leading-relaxed sm:leading-relaxed whitespace-pre-wrap opacity-90"
                style={{ color: styles.bodyColor, fontFamily: styles.bodyFontStyle }}
              >
                {body}
              </p>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default RichTextBlockRenderer;
